import React from 'react'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'
import CompactWorkItemHeader from '@Components/WorkItemV2/Catalog/CompactWorkItemHeader'

const CatalogCompactWorkItemHeader = () => (
    <CompactWorkItemHeader>
        <span className="label-with-tooltip">
            Share Amounts
            <CustomToolTip
                info={
                    <>
                        <b>Your Shares:</b> This represents the total shares you have claimed on this work.
                        <br />
                        <br />
                        <b>Total Known Shares:</b> This reflects total claimed shares on this work by all parties. If
                        part of these shares is unknown, the total will be less than 100%.
                    </>
                }
                inverse
                type="?"
            />
        </span>
    </CompactWorkItemHeader>
)

export default CatalogCompactWorkItemHeader
